module.exports = __webpack_public_path__ + "static/media/tom_oh.9c492d53.png";